var twig = require("twig").twig,
    tokens = [{"type":"raw","value":"<input (input) type=\"time\">"}],
    template = twig({"id":"$resolved:142349cc12dd70b7f0bb9f20a93ae81f32d651efeb508ed89763bfca55f06224b62e8c85dcc6d584d277c2197d63d8c07dfa9873f604f70b6a2834a4714a262f:magic-input-time.twig","data":[{"type":"raw","value":"<input (input) type=\"time\">"}],"allowInlineIncludes":true,"rethrow":true});

module.exports = function(context) { return template.render(context); }

module.exports.tokens = tokens;